'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index$1 = require('../../utils/geometry/index.js');

var createProjectionState = function () {
  return {
    isEnabled: false,
    isTargetLocked: false,
    target: index$1.axisBox(),
    targetFinal: index$1.axisBox()
  };
};
function createLayoutState() {
  return {
    isHydrated: false,
    layout: index$1.axisBox(),
    layoutCorrected: index$1.axisBox(),
    treeScale: {
      x: 1,
      y: 1
    },
    delta: index$1.delta(),
    deltaFinal: index$1.delta(),
    deltaTransform: ""
  };
}
var zeroLayout = createLayoutState();

exports.createLayoutState = createLayoutState;
exports.createProjectionState = createProjectionState;
exports.zeroLayout = zeroLayout;
